<template>
  <el-row>
    <el-col :span="24">
      <fieldset>
        <legend>Image</legend>
          <UploadImage />       
      </fieldset>
    </el-col>
  </el-row>
</template>

<script>
import UploadImage from './UploadImageArtist'
export default {
  components: {
    UploadImage
  }
}
</script>
